<template>
  <faq-list />
</template>

<script>
import faqList from "@/components/lists/faq/faqList";

export default {
  name: "faq-page",
  components: {
    faqList,
  },
  beforeRouteLeave(to, from, next) {
    window.scrollTo({
      top: 0,
    });

    next();
  },
  created() {
    this.$log("menu_faq");
  },
};
</script>
